// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"8bbb0841","121":"8df76f05","530":"8bbb0841","927":"8bbb0841"}[chunkId] + ".chunk.css";
};